import $ from "jquery"
import request_body from './request_body';

function login_request(path, params, contentType) {
    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    return new Promise((resolve, reject)=>{
        let vo = {
            url: request_body.login_url + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(JSON.parse(data));
            },
            error: (e) => {
                console.log(e)
                if (e.status == 401) {
                    window.location.href = "/login"
                }
                reject(e.responseJSON)
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        // if (request_body.token != null && request_body.token != "" && path != "/login/auth") {
        //     vo.headers.token = request_body.token;
        // }
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

function request(path, params, contentType) {
    if (request_body.url == null || request_body.url == "") {
        window.location.href = "/login"
    }

    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    
    return new Promise((resolve, reject)=>{
        let vo = {
            url: request_body.url + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(JSON.parse(data));
            },
            error: (e) => {
                console.log(e)
                if (e.status == 401) {
                    window.location.href = "/login"
                }
                reject(e.responseJSON)
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        // if (request_body.token != null && request_body.token != "" && path != "/login/auth") {
        //     vo.headers.token = request_body.token;
        // }
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

function patch_request(path, params, contentType) {
    return new Promise((resolve, reject)=>{
        let vo = {
            url: "https://update.91mgame.com" + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(JSON.parse(data));
            },
            error: (e, status, error) => {
                console.log(e, status, error)
                if (e.status == 401) {
                    window.location.href = "/admin_login"
                    return;
                }
                reject(e.responseJSON)
            },
        }
        if (contentType != null) {
            vo.contentType = contentType;
            if (contentType == "application/json") {
                vo.data = JSON.stringify(params)
            }
        }
        
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

function patch_get(path, params, contentType) {
    return new Promise((resolve, reject)=>{
        let vo = {
            url: "https://update.91mgame.com" + path,
            type: "GET",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(JSON.parse(data));
            },
            error: (e, status, error) => {
                console.log(e, status, error)
                if (e.status == 401) {
                    window.location.href = "/admin_login"
                    return;
                }
                reject(e.responseJSON)
            },
        }
        if (contentType != null) {
            vo.contentType = contentType;
            if (contentType == "application/json") {
                vo.data = JSON.stringify(params)
            }
        }
        
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

export {
    request, login_request, patch_request, patch_get
}

